module.exports = __webpack_public_path__ + "media/customizations/mywilloway/back-5f3b63bf063296ed444332d66eb64c11.jpg";